import React from "react";
import {
  ButtonEdit,
  ButtonDelete,
  EditElementClick,
} from "../../common/Buttons";
import { IconDot } from "../../Layout/Icons";

function TableColumnSupplier({ item, onDelete, index, onEdit }) {
  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">{item.id}</td>
      <td className="align-middle">
        {" "}
        <EditElementClick
          onEdit={() => onEdit("edit", index)}
          name={item.title}
        />
      </td>
      <td className="align-middle">
        {" "}
        <EditElementClick
          onEdit={() => onEdit("edit", index)}
          name={item.name}
        />
      </td>
      <td className="align-middle">{item.in_pim ? "YES" : "NO"}</td>
      <td className="align-middle">{item.code}</td>
      <td className="align-middle">{item.rivile_supplier_code}</td>
      <td className="align-middle">{item.vv_rivile_supplier_code}</td>
      <td className="align-middle">{item?.pickup_address?.code}</td>
      <td className="align-middle">{item?.country?.name}</td>
      <td className="align-middle">{item.is_code ? "YES" : "NO"}</td>
      <td className="align-middle">{item.is_active ? "Active" : "Inactive"}</td>
      <td className="align-middle">{item.comment}</td>
      <td className="align-middle">
        <IconDot
          className={item.auto_invoice ? "text-success" : "text-danger"}
        />
      </td>
      <td className="align-middle">{item?.parent_supplier?.title}</td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit onEdit={() => onEdit("edit", index)} />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonDelete onDelete={() => onDelete(item.id)} />
      </td>
    </tr>
  );
}

export default TableColumnSupplier;
